import React, { useState } from 'react';
import { string, func, node, oneOfType, arrayOf, bool } from 'prop-types';
import { Tooltip } from '@twigeducation/ts-fe-components';
import { Container } from './DrawingToolButton.styled';

const DrawingToolButton = ({ className, onClick, children, tooltipTitle, tooltipText, ariaLabel, ariaPressed }) => {
    const [zIndex, setZIndex] = useState(0);

    const onFocus = () => setZIndex(1000);
    const onBlur = () => setZIndex(0);

    return (
        <Container zIndex={zIndex}>
            <Tooltip placement="right" title={tooltipTitle} text={tooltipText}>
                <button
                    aria-label={ariaLabel}
                    aria-pressed={ariaPressed}
                    className={className}
                    onBlur={onBlur}
                    onBlurCapture={onBlur}
                    onClick={onClick}
                    onFocus={onFocus}
                    onFocusCapture={onFocus}
                    onMouseOut={onBlur}
                    onMouseOver={onFocus}
                    type="button"
                >
                    {children}
                </button>
            </Tooltip>
        </Container>
    );
};

DrawingToolButton.defaultProps = {
    className: '',
    ariaLabel: '',
    ariaPressed: false,
};

DrawingToolButton.propTypes = {
    tooltipTitle: string.isRequired,
    tooltipText: string.isRequired,
    className: string,
    ariaLabel: string,
    onClick: func.isRequired,
    children: oneOfType([node, arrayOf(node)]).isRequired,
    ariaPressed: bool,
};

export default DrawingToolButton;
